import { request, errHandler } from "./heimdall";
import store from "../store";

function login(credentials) {
  return request
    .post("/auth/login", {
      email: credentials.email,
      password: credentials.password
    })
    .then(({ data }) => {
      return data;
    })
    .catch(errHandler);
}

function checkSession(id) {
  return request
    .get(`/users/${id}`, {
      headers: {
        Authorization: store.getters.getToken
      }
    })
    .then(({ data }) => {
      return data;
    })
    .catch(errHandler);
}
export { login, checkSession };
